import React from 'react';
import { startOneSignal } from '../../../providers/oneSignal';

export class StartOneSignal extends React.Component<{}> {
  componentDidMount() {
    startOneSignal();
  }

  render() {
    return null;
  }
}
